require 'angular'

angular.module('workflow.app')

.directive 'fakeProgress', ( $timeout ) ->
  return {
    scope: {}
    controller: ($scope) ->
      incTimeout = undefined
      $scope.status = 0
      PROGRESS_TICKER_TIMEOUT = 500

      # For the unit test
      $scope.cancelTimeout = () ->
        $timeout.cancel(incTimeout)

      setPercentage = (stat) ->
        $scope.status = stat

        $timeout.cancel(incTimeout)
        incTimeout = $timeout(() ->
          calcPercentage()
        , PROGRESS_TICKER_TIMEOUT)

      calcPercentage = () ->
        rnd = 0
        stat = $scope.status
        if (stat >= 0 && stat < 25)
          rnd = (Math.random() * (5 - 3 + 1) + 3)
        else if (stat >= 25 && stat < 65)
          rnd = (Math.random() * 3)
        else if (stat >= 65 && stat < 9)
          rnd = (Math.random() * 2)
        else if (stat >= 9 && stat < 99)
          rnd = 0.5
        else
          rnd = 0
        setPercentage(rnd + stat)

      calcPercentage()

      $scope.$on '$destroy', () ->
        $timeout.cancel(incTimeout) if incTimeout?
    template: require('./progress.html')
  }
